import { render, staticRenderFns } from "./referenceTile.vue?vue&type=template&id=361c116a&"
import script from "./referenceTile.vue?vue&type=script&lang=ts&"
export * from "./referenceTile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports